import { render, staticRenderFns } from "./Surfaces.vue?vue&type=template&id=d20b224a&scoped=true"
import script from "./Surfaces.vue?vue&type=script&lang=js"
export * from "./Surfaces.vue?vue&type=script&lang=js"
import style0 from "./Surfaces.vue?vue&type=style&index=0&id=d20b224a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20b224a",
  null
  
)

export default component.exports